import { useContext, useEffect } from 'react';
import { Context as AuthContext } from 'contexts/auth';
import { Context as CompanyContext } from 'contexts/company';
import { useNavigate } from 'react-router-dom';

export const Logout = () => {
  const { logout } = useContext(AuthContext);
  const { clearOnLogout } = useContext(CompanyContext);
  const navigate = useNavigate();

  useEffect(() => {
    const init = async () => {
      await logout(() => navigate('/login'));
      clearOnLogout();
    };

    init();
  }, []);

  return null;
};
